import { Body, Icon, useTheme } from "@merit/frontend-components";
import { Header } from "@src/components";
import { StyleSheet, View } from "react-native";
import { useNavigation } from "@src/hooks";
import type { ViewStyle } from "react-native";

export const PushNotificationsInfo = () => {
  const { theme } = useTheme();
  const styles = StyleSheet.create<{
    readonly container: ViewStyle;
  }>({
    container: {
      backgroundColor: theme.colors.background.white,
    },
  });

  const { goBack } = useNavigation();

  return (
    <View style={styles.container}>
      <Header
        leftElement={<Icon name="chevronLeftMediumAction" />}
        leftOnPress={() => {
          goBack();
        }}
        title="Push Notifications"
        titleBold
        titleLevel="3"
      />
      <Body>Push notifications are iOS or Android only at the moment.</Body>
    </View>
  );
};
